module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Mobilyze_image_2.0e7d551b.jpg";